import { render, staticRenderFns } from "./DestroyUserModal.vue?vue&type=template&id=274a3770"
import script from "./DestroyUserModal.vue?vue&type=script&lang=js"
export * from "./DestroyUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports